module.exports = __webpack_public_path__ + "static/media/mmm-thumbsup-home.c83a2b90.svg";